import React, { useState, useEffect } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate, Link } from "react-router-dom";
import AlertComponent from "../Components/AlertComponent";
import { useLogin, useLogout } from "../hooks/auth";
import { auth } from "../lib/firebaseConfig";
import "./Login.css";
import {
  Typography,
  Box,
  Button,
  TextField,
  Chip,
} from "@mui/material";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { login, isLoading, toast, setToast } = useLogin();
  const navigate = useNavigate();
  const [authUser, authLoading, error] = useAuthState(auth);
  const { logout } = useLogout();

  const handleSubmit = async (e) => {
    e.preventDefault();
    login({
      email,
      password,
      redirectTo: "/",
    });
  };

  /* Quotes */
  const [quote, setQuote] = useState("");

  useEffect(() => {
    fetch("https://api.quotable.io/random?tags=business")
      .then((response) => response.json())
      .then((data) => setQuote(data.content))
      .catch((error) => console.log(error));
  }, []);
  useEffect(() => {
    if (authLoading) return;
    if (authUser) logout();
  }, [authLoading]);
  return (
    <section
      className="min-h-screen flex flex-row login-wrapper"
      style={{ background: "url('../img/scratch.webp)", alignContent: "center" }}
    >
      <div className="p-6 login-container" style={{ width: "70%" }}>
        <form onSubmit={handleSubmit}>
          <img
            src="https://uploads-ssl.webflow.com/63ff96d0ec9f196370caf50c/63ffc0597847ba335fb02b87_8CD41791-916C-4A1F-9551-C4A6FC79F96D.svg"
            alt="Luna-chatbot-ai-logo"
            style={{
              width: "80px",
              margin: "auto auto",
              background: "black",
              borderRadius: "100%",
            }}
          />

          <Typography variant="h4" className="text-center font-semibold mt-6">
            Sign In
          </Typography>
          <Typography variant="body2" className="mt-2 text-center text-gray-800">
            Log in with your data that you entered during your registration.
          </Typography>
          <Box sx={{ mt: 6, mb: 2 }}>
            <TextField
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              label="Email"
              variant="outlined"
              fullWidth
              required
              placeholder="richard@piedpiper.com"
            />
          </Box>
          <Box sx={{ mb: 1 }}>
            <TextField
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              label="Password"
              variant="outlined"
              type="password"
              fullWidth
              required
              placeholder="******"
            />
          </Box>
       
          {error && (
            <Box sx={{ mb: 2 }}>
              <Chip label={error} color="error" variant="outlined" />
            </Box>
          )}
          <Button
            disabled={isLoading}
            type="submit"
            variant="contained"
            fullWidth
            style={{ background: "linear-gradient(45deg, #ff2045, #3d2fff)", marginTop: '15px' }}
          >
            Sign in
          </Button>


          <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: '10px', marginTop: '10px', cursor: 'pointer'}}>
            <Link to='/signup'>
            <Typography
            variant="body2"
            className="text-center text-gray-500" sx={{fontSize: '12px'}}>
                Sign up
            </Typography>
              </Link>

          <Link to="/forgot-password">
            <Typography
              variant="body2"
              className="text-center cursor-pointer text-gray-500"
              sx={{fontSize: '12px'}}
              >
              Forgot password?
            </Typography>
          </Link>
              </Box>


        </form>
      </div>
      <div
        className="image-section"
        style={{
          width: "50%",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img
          className="rounded-lg"
          src={"https://app.svgator.com/assets/svgator.webapp/log-in-girl.svg"}
          alt="placeholder"
          style={{ maxWidth: "90%", margin: "auto auto", borderRadius: "100%" }}
        />
        {quote && (
          <Typography
            variant="body2"
            className="citation"
            style={{
              margin: "50px",
              color: "white",
              transform: "translateY(-10px)",
              fontStyle: "italic",
              fontSize: "12px",
              textAlign: "center",
            }}
          >
            {quote}
          </Typography>
        )}
      </div>
      <AlertComponent alert={toast} setOpenAlert={setToast} />
    </section>
  );
};

export default Login;
